<template>
<div class="">

  <div class="row vpad"> 
    <div class="col s12 yo-align-center"><img src="../assets/logo.png" style="height:240px;"/></div>
  </div>

  <el-form ref="formBasic" :model="$partecipante.contatto.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">

<!--
<div style="color:red;font-weight:bold;margin-botton:30px;">
ATTENZIONE!!!
<br />
<br />

 

I 65 posti aventi diritto ai crediti ECM sono esauriti
<br />
La Sua iscrizione ai fini ECM sarà inserita in lista d’attesa.
<br />
La Segreteria Organizzativa Le comunicherà l’esito entro il 18.10.2019.

<br /><br />
&#160;
</div> 
-->
  Si fa presente che il corso è a numero chiuso per un massimo di 100 partecipanti ed è accreditato esclusivamente per i Medici Chirurghi e gli Odontoiatri iscritti all’Albo dei Medici Chirurghi e degli Odontoiatri della Provincia di Bergamo.
  
  <br />
Una volta raggiunto il numero massimo di iscrizioni verrà data comunicazione su questa pagina. Le iscrizioni successive verranno messe in lista d’attesa
<br />

&#160;
   <div class="title_h1 yo-color-primary" style="margin-top:30px;">MODULO DI REGISTRAZIONE</div>

   <div class="row pad" style="margin-top:20px;">
          
      <div class="col s12 m6">
      <el-form-item label="Cognome" prop="cognome">
        <el-input  v-model="$partecipante.contatto.row.cognome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nome" prop="nome">
        <el-input  v-model="$partecipante.contatto.row.nome"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 m6">
      <el-form-item label="Email" prop="email">
        <el-input  v-model="$partecipante.contatto.row.email"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Reinserisci Email" prop="emailcheck"  class="is-required">
        <el-input  v-model="emailcheck"></el-input>
      </el-form-item>
      </div> 

<!--
      <div class="col s12 m6 clear">
      <el-form-item label="Data di nascita" prop="datanascita" class="is-required">
        <el-date-picker v-model="$partecipante.contatto.row.datanascita" type="date" placeholder="Indica la tua data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div> 


      <div class="col s12 m6">
      <el-form-item label="Sesso" prop="sesso">
        <el-select v-model="$partecipante.contatto.row.sesso"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Maschio" value="M" ></el-option>
          <el-option label="Femmina" value="F" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nazione di nascita" prop="natonazione">
        <el-select v-model="$partecipante.contatto.row.natonazione"  filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nome" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>
   

      <div class="col s12 m6" v-if="$partecipante.contatto.row.natonazione=='ITA'">
      <el-form-item label="Provincia di nascita" prop="natoprovincia">
        <el-select v-model="$partecipante.contatto.row.natoprovincia" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.sigla" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6" v-if="$partecipante.contatto.row.natonazione=='ITA'">
      <el-form-item label="Città di nascita" prop="luogonascita">
        <el-select v-model="$partecipante.contatto.row.luogonascita" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._comune" v-if="item.provincia==$partecipante.contatto.row.natoprovincia" :key="item.id" :label="item.nome" :value="item.nome" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      
      <div class="col s12" v-if="$partecipante.contatto.row.natonazione!='ITA'">
      <el-form-item label="Città di nascita" prop="luogonascita">
        <el-input  v-model="$partecipante.contatto.row.luogonascita"></el-input>
      </el-form-item>
      </div>
-->


      <div class="col s12 m6">
      <el-form-item label="Codice Fiscale" prop="codicefiscale">
        <el-input  v-model="$partecipante.contatto.row.codicefiscale"></el-input>
      </el-form-item>
      </div>
<!--
      <div class="col s12">
      <el-form-item label="Domicilio" prop="indirizzo">
        <el-input  v-model="$partecipante.contatto.row.indirizzo"></el-input>
      </el-form-item>
      </div>

      <div class="col s12 m6">
      <el-form-item label="CAP" prop="cap">
        <el-input  v-model="$partecipante.contatto.row.cap"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Provincia" >
        <el-select v-model="$partecipante.contatto.row.pr"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.id" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div> 
-->
      <div class="col s12 m6">
      <el-form-item label="Città" prop="citta">
        <el-input  v-model="$partecipante.contatto.row.citta"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Azienda" prop="azienda">
        <el-input  v-model="$partecipante.contatto.row.azienda"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="È interessato ai crediti ECM" prop="creditiecm">
        <el-select v-model="$partecipante.contatto.row.creditiecm"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="SI" value="SI" ></el-option>
          <el-option label="NO" value="NO" ></el-option>
        </el-select>
      </el-form-item>
      </div>



      <div class="col s12 m6">
      <el-form-item label="Categoria" prop="categoria">
        <el-select v-model="$partecipante.contatto.row.categoria"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Medico Chirurgo" value="1" ></el-option>
        </el-select>
      </el-form-item>
      </div>



      <div class="col s12 m6">
      <el-form-item label="Disciplina" prop="luogonascita">
        <el-select v-model="$partecipante.contatto.row.disciplina" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $discipline" :key="item.id" :label="item.label" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      </div>



<!--
      <div class="col s12 m6">
      <el-form-item label="Cellulare" prop="cell">
        <el-input  v-model="$partecipante.contatto.row.cell"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Telefono Casa" prop="telcasa">
        <el-input  v-model="$partecipante.contatto.row.telcasa"></el-input>
      </el-form-item>
      </div> 
-->

    </div>





    <div class="title_h1 yo-color-primary" style="margin-top:30px;">Informativa GDPR in vigore dal 25 maggio 2018 </div>
    
    <div class="row pad" style="margin-top:20px;">


        <div class="col s12" style="padding-bottom:20px;padding-top:10px;">

          
Compilando liberamente il presente modulo, autorizzo Centro Congressi Giovanni XXIII a gestire i miei dati personali secondo quanto descritto nell’informativa sul trattamento dei dati personali, conforme al Regolamento EU 2016/679 (GDPR) del 27.4.2016, visibile al seguente <a href="https://centrocongressibergamo.com/privacy">link</a>
<br />
Per informazioni o comunicazioni relative al trattamento dei dati personali, inviare una mail a: <a href="mailto:info@centrocongressibergamo.com">info@centrocongressibergamo.com</a>


        </div>



    </div>



    <div class="row pad" style="margin-top:20px;">
      <div class="col s6 m4 offset-m1">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">non ora, torna al sito</el-button>
      </div>
        
      <div class="col s6 m4 offset-m1">
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#002f6d;border:none;margin:10px 0;">Registrati</el-button>
      </div>
    </div>


    </el-form>



</div>
</template>

<script>
import emailConfirm from './Email-confirm.vue'
export default {
  name: 'socio-edit',
  components: {

  },
  data() {
    return {
      itm: this.$partecipante.contatto.row, //mi serve per far si che funzioni correttamente il binding
      emailcheck:'',
      authcheck: this.$moment().format('YYYY-MM-DD'),
      checkEmail: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value.toString()!=this.$partecipante.contatto.email) {
          return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
        }else{
          callback();
        }
      }
    }
  },
  created () {
    console.log("Arrivo a Registrazione.vue")
    this.$teras.pageTitle = (this.$partecipante.contatto.row.id=='') ? 'Nuova Attività' : 'Modifica Attività: '+this.$partecipante.contatto.row.id

    
    console.log(this.$partecipante.contatto.row)
  },
  beforeDestroy () {
    clearInterval(this.minInterval)
  },
  methods: {
    onCancel() {
        //this.$router.go(-1)
        //this.$router.push('/nograzie/')
        document.location = "https://www.centrocongressibergamo.com/calendario-page/"
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {
          console.log(this.$partecipante.contatto.row)

          if(this.$partecipante.contatto.row.email != this.emailcheck){
            this.$notify.error({
              title: 'Errore',
              message: 'L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'
            });
          }else{
            let error = 0
            let checkEmail = await this.$partecipante.checkEmail(this.$partecipante.contatto.row.email)
            if(checkEmail==false)
              error = 101

            let checkCodicefiscale = await this.$partecipante.checkCodicefiscale(this.$partecipante.contatto.row.codicefiscale)
            if(checkCodicefiscale==false)
              error = 201

            if(error==0){
              this.$partecipante.contatto.row.inseritoil = this.$teras.moment().format('YYYY-MM-DD HH:mm:ss')
              this.Save()

              var html = this.$teras.renderVue(emailConfirm,{contatto:this.$partecipante.contatto.row})
              this.$axios.email({from:'eventi@centrocongressibergamo.com',oggetto:'Iscrizione completata',to:this.$partecipante.contatto.row.email,body:html}).then((data) => {
                console.log("Email con invio credenziali inviata")
              }).catch((error) => {
                console.log("Errore nell'invio della email con le credenziali")
                console.log(error)
              })
              this.$axios.email({from:'eventi@centrocongressibergamo.com',oggetto:'Iscrizione completata da '+this.$partecipante.contatto.row.cognome+' '+this.$partecipante.contatto.row.nome,to:"eventi@centrocongressibergamo.com",body:html}).then((data) => {
                console.log("Email con invio credenziali inviata")
              }).catch((error) => {
                console.log("Errore nell'invio della email con le credenziali")
                console.log(error)
              })
                
            }else{
              this.$notify.error({
              title: 'Errore '+error,
              message: 'Lei sembra già essere tra i nostri registrati o ha già provato ad iscriversi, la preghiamo di contattare la segreteria!'
              })

            }

            
            /*.then((data) => {
              if(data){
                this.Save()
              }else{
                parent;
              }
            })
            */
          }
        } else {
          return false;
        }
      });
    },
    Save(){
      //this.$partecipante.contatto.row.utente = this.$teras.utente.id
      //if( !moment(this.$partecipante.contatto.row.inseritoil).isValid())
        //this.$partecipante.contatto.row.inseritoil = moment().format('YYYY-MM-DD HH:mm:00')


      this.$partecipante.contatto.row.cognome = this.$partecipante.contatto.row.cognome.toUpperCase()
      this.$partecipante.contatto.row.nome = this.$partecipante.contatto.row.nome.toUpperCase()
      this.$partecipante.contatto.row.inseritoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
      this.$partecipante.contatto.row.step = 10
      
      this.$partecipante.contatto.save().then(data => {
        this.$storage.save("utente",this.$partecipante.contatto.row.id)
        //this.$axios.get('https://diventasocio.biomedia.net/'+this.$partecipante.sigla.toLowerCase()+'/schedaesternasolopdf/id/'+this.$partecipante.contatto.row.id)
        this.$router.push('/fine/')
      })
      
      
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
        cognome: [
          { required: true, message: 'Il cognome è obbligatorio', trigger: 'blur'  }
        ],
        nome: [
          { required: true, message: 'Il nome è obbligatorio', trigger: 'blur' }
        ],
        creditiecm: [
          { required: true, message: 'NOn hai indicato una scelta'}
        ],
        emailchecks: [
          { required: true, message: 'L\'indirizzo email di controllo è obbligatorio'}
        ],     
        email: [
          { required: true, message: 'L\'indirizzo email è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email corretto', trigger: 'blur,change' }
        ],

        codicefiscale: [
          { required: true, message: 'Il codice fiscale è obbligatorio'}
        ], 
        citta: [
          { required: true, message: 'La città di residenza è obbligatoria', trigger: 'blur' }
        ], 
        categoria: [
          { required: true, message: 'La categoria è obbligatoria', trigger: 'blur' }
        ], 
        disciplina: [
          { required: true, message: 'La disciplina è obbligatoria', trigger: 'blur' }
        ]            
      }
      return rulesNow
    }
  }
}
</script>
<style>
/*
.el-checkbox {
    width: 100%;
    margin: 0 !important;
}.el-form-item__label{
  width: 16.66% !important;
}.el-form-item__content{
  margin-left: 16.66% !important;

}.col.m6 .el-form-item__label{
  width: 33.32% !important;
}.col.m6 .el-form-item__content{
  margin-left: 33.32% !important;


}.col.m4 .el-form-item__label{
  width: 50% !important;
 */ 
.el-switch.is-checked .el-switch__core{
  background-color:#002f6d;
  border-color:#002f6d;


}.el-upload{
  display:block !important;
}.el-upload-dragger{
  height:100px !important;
  width:100% !important;
}
</style>